import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=613c9a8e&scoped=true"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=613c9a8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613c9a8e",
  null
  
)

export default component.exports